import { isApp } from "./Utilities";

// Function to get a cookie by name
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
  return null;
};

// Function to delete a cookie
export const deleteCookie = (name, domain = 'localhost') => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}`;
};

// Function to set a cookie
export const setCookie = (name, value, days = 365) => {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};

// Initialize cookies - Move from localStorage to cookies or vice versa
export const initializeCookies = () => {
  try {
    const jarvis = getCookie('tempJarvis');
    if (jarvis) {
      localStorage.setItem('Jarvis', jarvis);

      // Clear the tempJarvis cookie after storing in localStorage
      deleteCookie('tempJarvis');

    }

    const cookiesToStore = ['getIDB', 'SignUp', 'account', 'source', 'LeadInfo'];
    cookiesToStore.forEach((cookieName) => {
      const value = getCookie(cookieName);
      if (value) {
        localStorage.setItem(cookieName, value);
      }
    });

  } catch (error) {
    console.error('Error during cookie initialization:', error);
  }
};

// Get all cookies as an object
export const getAllCookies = () => {
  const cookies = {};
  document.cookie.split(';').forEach(cookie => {
    const [name, value] = cookie.trim().split('=');
    if (name && value) {
      cookies[name] = decodeURIComponent(value);
    }
  });
  return cookies;
};

// Clear all cookies
export const clearAllCookies = () => {
  const cookies = getAllCookies();
  Object.keys(cookies).forEach(cookieName => {
    deleteCookie(cookieName);
  });
};

// Get user token from localStorage
export const getAuthToken = () => {
  return localStorage.getItem('Jarvis');
};

// Clear authentication data
export const clearEverything = () => {
  const isUserInApp = isApp();

  // Preserve fID before clearing
  const fID = localStorage.getItem('fID');
  
  localStorage.clear();
  
  // Restore fID after clearing
  if (fID) {
    localStorage.setItem('fID', fID);
  }
  
  indexedDB.deleteDatabase("SahiCRMIDB");
  window.history.replaceState(null, "", window.location.href);

  let redirect = isUserInApp ? "/AppIndex.html" : "/Web";
  window.open(redirect, "_self");
};